import { createAsyncThunk } from "@reduxjs/toolkit";

import type { PollService } from "@busbud/core-types";

import type { ApplicationContext } from "@app/context/app-context";
import type { ResultsReduxState } from "@app/types/results-redux-types";

import { openModal } from "../../../checkout/actions";
import { getTripSegmentStopsRelated } from "../../services/trip-stops";

interface GetTripStopsPayload {
  api: ApplicationContext["api"];
  trip_id: string;
}

interface ThunkConfig {
  state: ResultsReduxState;
  rejectValue: Error;
}

export const getTripSegmentStops = createAsyncThunk<
  PollService.API.GetAllSegmentStopsRelatedResponse,
  GetTripStopsPayload,
  ThunkConfig
>(
  "results/getTripSegmentStops",
  async ({ trip_id, api }, { dispatch, rejectWithValue }) => {
    try {
      return await getTripSegmentStopsRelated(api, trip_id);
    } catch (err) {
      // TODO-ABNER: why we are displaying an error opening the modal here?
      dispatch(
        openModal({
          type: "error_message",
          error: err,
          is_async_cart: false
        })
      );

      return rejectWithValue(err as Error);
    }
  }
);
